
























































































































































































































































































































import HomeRemuneracaoStore from '@/components/Home/Store/HomeRemuneracaoStore'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { contains, maskMoney } from '@/utils/common'

@Component
export default class ComponentCardRemuneracao extends Vue {
  remuneracaoEnabled: boolean = false
  dataReady: boolean = false
  isRecebidoActive: boolean = false
  isAReceberActive: boolean = false
  isProvisionadosActive: boolean = false
  modalRecebido: boolean = false
  modalAReceber: boolean = false
  dtSelecionada: string = '05-2023'

  get dataSelecionada() { return this.dtSelecionada }
  set dataSelecionada(value: string) { this.dtSelecionada = value }

  get recebidoDetails() { return this.modalRecebido }
  set recebidoDetails(value: boolean) { this.modalRecebido = value }

  get aReceberDetails() { return this.modalAReceber }
  set aReceberDetails(value: boolean) { this.modalAReceber = value }

  datas: any[] = [
    { periodo: '05-2023', label: 'MAI/23' },
    { periodo: '04-2023', label: 'ABR/23' },
    { periodo: '03-2023', label: 'MAR/23' },
    { periodo: '02-2023', label: 'FEV/23' },
    { periodo: '01-2023', label: 'JAN/23' },
    { periodo: '12-2022', label: 'DEZ/22' },
  ]

  openModal() {
    this.recebidoDetails = true
  }

  openModalReceber() {
    this.aReceberDetails = true
  }

  get getHomeRemuneracaoStore() {
    return getModule(HomeRemuneracaoStore, this.$store)
  }

  get tableData() {
    if (this.isRecebidoActive) return this.getHomeRemuneracaoStore.recebidoData
    if (this.isAReceberActive) return this.getHomeRemuneracaoStore.aReceberData
    if (this.isProvisionadosActive) return this.getHomeRemuneracaoStore.provisionadosData
    return []
  }

  get tableHeader() {
    if (this.isRecebidoActive) return this.getHomeRemuneracaoStore.recebidoTableHeader
    if (this.isAReceberActive) return this.getHomeRemuneracaoStore.aReceberTableHeader
    if (this.isProvisionadosActive) return this.getHomeRemuneracaoStore.provisionadosTableHeader
    return []
  }

  get recebidoTotal() {
    return 41599
    // return this.getHomeRemuneracaoStore.recebidoTotal || 0
  }

  get aReceberTotal() {
    return 12621
    // return this.getHomeRemuneracaoStore.aReceberTotal || 0
  }

  get provisionadosTotal() {
    return this.getHomeRemuneracaoStore.provisionadosTotal || 0
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  showDetails(area: string) {
    if (area === 'isRecebidoActive' && this.isRecebidoActive) {
      this.isRecebidoActive = false
      return
    }

    if (area === 'isAReceberActive' && this.isAReceberActive) {
      this.isAReceberActive = false
      return
    }

    if (area === 'isProvisionadosActive' && this.isProvisionadosActive) {
      this.isProvisionadosActive = false
      return
    }

    switch (area) {
      case 'isRecebidoActive':
        this.isRecebidoActive = true
        this.isAReceberActive = false
        this.isProvisionadosActive = false
        return
      case 'isAReceberActive':
        this.isRecebidoActive = false
        this.isAReceberActive = true
        this.isProvisionadosActive = false
        return
      case 'isProvisionadosActive':
        this.isRecebidoActive = false
        this.isAReceberActive = false
        this.isProvisionadosActive = true
        break
      default:
        // eslint-disable-next-line consistent-return
        return false
    }
  }

  async init() {
    const request = await this.getHomeRemuneracaoStore.getRecebimentoSummaryData()
    if (request.success) {
      this.dataReady = true
    }
  }

  async created() {
    if (contains(this.$user.profile.pageAuthorized, ['producao', 'recebimento', 'relatorio'])) {
      this.remuneracaoEnabled = true
      await this.init()
    }
  }

  windowWidth: number = 0

  get mobileBreakpoint() {
    return this.windowWidth < 768
  }

  get tabletBreakpoint() {
    return this.windowWidth < 960
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
